import { getUrlParam } from 'core-components/helpers/url'
import {
  P360_TAB_SCROLL_QUERY_PARAM,
  P360_TAB_SCROLL_QUERY_VALUE,
  TAB_URL,
} from 'partner360/configs'

interface IShouldScrollToP360TabsArgs {
  pathname: string
  search: string
  availableTabIds: readonly string[]
}

const splitUrlSuffix = (url: string) => {
  const queryIndex = url.indexOf('?')
  const hashIndex = url.indexOf('#')
  const separatorIndexes = [queryIndex, hashIndex].filter((index) => index >= 0)
  const suffixStartIndex = separatorIndexes.length > 0 ? Math.min(...separatorIndexes) : url.length

  return {
    pathname: url.slice(0, suffixStartIndex),
    suffix: url.slice(suffixStartIndex),
  }
}

export const isP360TabScrollRequested = (search: string) => {
  const searchParams = new URLSearchParams(search)

  return searchParams.get(P360_TAB_SCROLL_QUERY_PARAM) === P360_TAB_SCROLL_QUERY_VALUE
}

export const getRequestedP360TabId = (pathname: string) => getUrlParam(TAB_URL, pathname)?.trim()

export const appendP360TabScrollIntent = (url: string) => {
  const { pathname, suffix } = splitUrlSuffix(url)
  const hashIndex = suffix.indexOf('#')
  const search = hashIndex >= 0 ? suffix.slice(0, hashIndex) : suffix
  const hash = hashIndex >= 0 ? suffix.slice(hashIndex) : ''
  const searchParams = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)

  searchParams.set(P360_TAB_SCROLL_QUERY_PARAM, P360_TAB_SCROLL_QUERY_VALUE)

  return `${pathname}?${searchParams.toString()}${hash}`
}

export const removeP360TabScrollIntent = (search: string) => {
  const searchParams = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)

  searchParams.delete(P360_TAB_SCROLL_QUERY_PARAM)

  const nextSearch = searchParams.toString()

  return nextSearch ? `?${nextSearch}` : ''
}

export const shouldScrollToP360Tabs = ({
  pathname,
  search,
  availableTabIds,
}: IShouldScrollToP360TabsArgs) => {
  const requestedTabId = getRequestedP360TabId(pathname)

  return (
    !!requestedTabId && availableTabIds.includes(requestedTabId) && isP360TabScrollRequested(search)
  )
}
